// extracted by mini-css-extract-plugin
export default {"form":"Registration_form__S2Tgy","wrapper":"Registration_wrapper__GJjSF","button":"Registration_button__a+BRV"};